import {
  Button,
  CardBody,
  CardFooter,
  CardHeader,
  Divider,
  Input,
} from "@heroui/react"
import classes from "../../styles/NewTeacher.module.scss"

interface Props {
  onSubmit: React.FormEventHandler<HTMLFormElement>
  loading: boolean
  values: Partial<KnowladgebaseCategory>
  onChange: React.Dispatch<React.SetStateAction<Partial<KnowladgebaseCategory>>>

  title: string
  ctaLabel: string
}
const CategoryForm = (props: Props) => {
  const { onSubmit, onChange, loading, values, title, ctaLabel } = props

  const onFieldChange = (name: string, value: string) => {
    onChange((prevLead) => ({ ...prevLead, [name]: value }))
  }

  return (
    <form onSubmit={onSubmit}>
      <CardHeader>{title}</CardHeader>
      <Divider />
      <CardBody>
        <div className={classes.form}>
          <Input
            key="title"
            type="string"
            label="כותרת"
            disabled={loading}
            value={values?.title}
            onInput={(e) => onFieldChange("title", e.currentTarget.value)}
          />
          <Input
            key="slug"
            type="string"
            label="קישור"
            disabled={loading}
            value={values?.slug}
            onInput={(e) => onFieldChange("slug", e.currentTarget.value)}
          />
          <Input
            key="subtitle"
            type="string"
            label="תיאור"
            disabled={loading}
            value={values?.subtitle}
            onInput={(e) => onFieldChange("subtitle", e.currentTarget.value)}
          />
          <Input
            key="icon"
            type="string"
            label="אייקון"
            disabled={loading}
            value={values?.icon}
            onInput={(e) => onFieldChange("icon", e.currentTarget.value)}
          />
          <Input
            key="type"
            type="string"
            label="סוג אפליקציה"
            disabled={loading}
            value={values?.type}
            onInput={(e) => onFieldChange("type", e.currentTarget.value)}
          />
        </div>
      </CardBody>
      <CardFooter className={classes.footer}>
        <Button type="submit" fullWidth disabled={loading}>
          {ctaLabel}
        </Button>
      </CardFooter>
    </form>
  )
}
export default CategoryForm
